// extracted by mini-css-extract-plugin
module.exports = {"editorContent":"NoiDungModal_editorContent__3cPsr","button":"NoiDungModal_button__h6Tca","header":"NoiDungModal_header__2OTfY"};